module.exports = __webpack_public_path__ + "img/ic-plus.63a2dcfb.svg";